"use strict";

Shopify.theme.jsHeader = {
  init: function init($section) {
    var _this = this;

    // Add settings from schema to current object
    Shopify.theme.jsHeader = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors

    this.$el = $('#header');
    this.$menuToggle = this.$el.find('.header__menu-toggle');
    var announcementHeight = $('.announcement-sticky-wrapper').height(); // Overlaid header

    if (this.enable_overlay === true && isScreenSizeLarge()) {
      this.updateOverlayStyle(this.sectionUnderlayIsImage());
    } // Sticky header


    if (this.enable_sticky === true && isScreenSizeLarge()) {
      this.enableSticky(announcementHeight);
    }

    if (this.header_layout == 'centered' || this.header_layout == 'search_focus') {
      this.$menuToggle.on('click', function () {
        _this.showStickyMenu();
      });
    } else if (this.header_layout == 'vertical') {
      $section.find('.header-sticky-wrapper').stick_in_parent();

      if (Shopify.theme_settings.announcement_enabled == true) {
        Shopify.theme.jsAnnouncementBar.addVerticalHeaderTopMargin();
      }
    }

    if (!isScreenSizeLarge()) {
      this.unload();
      Shopify.theme.mobileMenu.init();
      Shopify.theme.jsHeader.openCloseSubmenuMobile();
    }
    $('.search-overlay__close').on('click', function () {
      Shopify.theme.jsHeader.hideSearch();
    });
    $(document).on('click', '[data-show-search-trigger]', function () {
      Shopify.theme.jsHeader.showSearch();
    });

    if (isScreenSizeLarge() || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      const $dropdownClickTrue = $('.dropdown-click--true');
      const $listItem = $dropdownClickTrue.find('.linklist__list-item');
      $listItem.on('click touchstart', function (e) {
        var $this = $(this);
        Shopify.theme.jsHeader.toggleMenuClick($this);
      });

      const $dropdownClickFalse = $('.dropdown-click--false');
      const $listItemOnHover = $dropdownClickFalse.find('.linklist__list-item');
      $listItemOnHover.on('mouseover', function (e) {
        var $this = $(this);
        Shopify.theme.jsHeader.toggleMenuOnHover($this);
      });

      $listItemOnHover.on('mouseleave', function () {
        //Hide mega menu upon leaving mega menu
        Shopify.theme.jsHeader.collapseMenu();
      });
    }

    $(document).on('keydown', '[data-show-search-trigger]', function (e) {
      if (e.which === 13) {
        Shopify.theme.jsHeader.showSearch();
      }
    });
  },
  toggleMenuClick: function toggleMenuClick($this) {
    var $parentWrap = $this.closest('.linklist__list-item');

    if (!$parentWrap.hasClass('is-opened') && $parentWrap.length !== 0 && $parentWrap.hasClass('link--has-children')) {
      // Close mega menu
      $parentWrap.removeClass('is-opened');
      $parentWrap.find('.linklist__submenu-wrapper').removeClass('visible');

      // Open selected mega menu
      $parentWrap.addClass('is-opened');
      $parentWrap.find('.linklist__submenu-wrapper').addClass('visible');
    } else {
      // Close mega menu
      $parentWrap.removeClass('is-opened');
      $parentWrap.find('.linklist__submenu-wrapper').removeClass('visible');
    }

    // Close dropdown if click anywhere outside dropdown menu
    $(document).on('click', function (e) {
    var $target = $(e.target);
    if (!$target.closest('.link--has-children').length) {
      Shopify.theme.jsHeader.collapseMenu();
    }
  });
  },
  collapseMenu: function collapseMenu() {
    $('.link--has-children').removeClass('is-opened');
    $('.linklist__submenu-wrapper').removeClass('visible');
  },
  toggleMenuOnHover: function toggleMenuOnHover($this){
    var $parentWrap = $this.closest('.linklist__list-item');
    if (!$parentWrap.hasClass('is-opened') && $parentWrap.hasClass('link--has-children') && $parentWrap.length !== 0) {
      //Toggle corresponding mega menu
      $('.link--has-children').removeClass('is-opened');
      $('.linklist__submenu-wrapper').removeClass('visible');
      // Open selected mega menu
      $parentWrap.addClass('is-opened');
      $parentWrap.find('.linklist__submenu-wrapper').addClass('visible');
    }
  },
  openCloseSubmenuMobile: function openCloseSubmenuMobile() {
    // Mobile Menu arrow action to open submenu
    $('.link__action--next').on('click touchstart', function(e) {
      e.preventDefault();
      // Select the next sibling element and add the class to it
      var nextChildElement = $(this).next('.linklist__submenu-wrapper');
      if (nextChildElement.length > 0) {
        nextChildElement.addClass('visible');
      }
    });

    // Mobile Menu back arrow action to go back to previous menu
    $('.link__action--back').on('click', function() {
      // Find the closest submenu-wrapper menu and remove visible class from it
      $(this).closest('.linklist__submenu-wrapper').removeClass('visible');
    });
  },
  showStickyMenu: function showStickyMenu() {
    this.$menuToggle.toggleClass('is-active');
    this.$el.find('.sticky-menu-wrapper').toggleClass('is-visible');
  },
  hideStickyMenu: function hideStickyMenu() {
    this.$menuToggle.removeClass('is-active');
    this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
  },
  disableSticky: function disableSticky() {
    var $stickyEl = $('#header');
    $stickyEl.unstick();
    $stickyEl.removeClass('sticky--enabled');
    setTimeout(function () {
      $stickyEl.css('height', 'auto');
    }, 250);
  },
  enableSticky: function enableSticky(offset) {
    var _this2 = this;

    var $stickyEl = this.$el;
    $stickyEl.addClass('sticky--enabled');
    $stickyEl.sticky({
      wrapperClassName: 'header-sticky-wrapper',
      zIndex: 40,
      topSpacing: offset || 0
    }).on('sticky-start', function () {
      var headerHeight;
      var announcementHeight; // Hide the mini cart for centered header layout

      if (Shopify.theme_settings.header_layout == 'centered') {
        $('[data-ajax-cart-trigger]').removeClass('show-mini-cart');
      } // Get header height is sticky enabled


      if (Shopify.theme.jsHeader.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
        headerHeight = Shopify.theme.jsHeader.getHeaderHeight();
      } // Get announcement height is sticky enabled


      if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
        announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
      } else {
        announcementHeight = 0;
      }

      var totalHeight = headerHeight + announcementHeight;
      $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');

      if (_this2.enable_overlay === true && _this2.sectionUnderlayIsImage() === true) {
        $stickyEl.parent().addClass('has-overlaid-header');

        _this2.disableOverlayStyle();
      } else if (_this2.enable_overlay === true) {
        _this2.disableOverlayStyle();
      }
    }).on('sticky-end', function () {
      $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%'); // Safety timeout for logo width transition which can throw calculated height off

      setTimeout(function () {
        $stickyEl.sticky('update');
      }, 250);

      _this2.$el.find('.sticky-menu-wrapper').removeClass('is-visible');

      _this2.$menuToggle.removeClass('is-active');

      if (_this2.enable_overlay === true && _this2.sectionUnderlayIsImage() === true) {
        _this2.updateOverlayStyle(_this2.sectionUnderlayIsImage());
      }
    });
  },
  disableOverlayStyle: function disableOverlayStyle() {
    $('[data-enable_overlay]').attr('data-enable_overlay', false);
  },
  enableOverlayStyle: function enableOverlayStyle() {
    $('[data-enable_overlay]').attr('data-enable_overlay', true);
  },
  updateOverlayStyle: function updateOverlayStyle(overlayBoolean) {
    $('[data-enable_overlay]').attr('data-enable_overlay', overlayBoolean);
  },
  sectionUnderlayIsImage: function sectionUnderlayIsImage() {
    var $firstSection = $('[data-check-for-order=true]').find('[id^=shopify-section]').first(); // Check whether the first element has class to indicate it should be under header when overlay is enabled

    if ($firstSection.hasClass('overlaid-header-option') && $.trim($firstSection.html()).length > 0) {
      return true;
    } else {
      return false;
    }
  },
  showSearch: function showSearch() {
    $('[data-show-search-trigger]').addClass('is-active');

    if (Shopify.theme_settings.search_layout == 'overlay') {
      $('[data-search-type="' + Shopify.theme_settings.search_layout + '"]').toggleClass('is-opened');
      $('.search-form .search__fields input[type="text"]').focus();
    } else {
      $.fancybox.open($('.js-search-popup'), {
        baseClass: 'search__lightbox',
        hash: false,
        infobar: false,
        toolbar: false,
        loop: true,
        smallBtn: true,
        mobile: {
          preventCaptionOverlap: false,
          toolbar: false
        },
        beforeClose: function beforeClose() {
          $('[data-show-search-trigger]').removeClass('is-active');
        }
      });
    }
  },
  hideSearch: function hideSearch() {
    $('[data-show-search-trigger]').removeClass('is-active');

    if (Shopify.theme_settings.search_layout == 'overlay') {
      $('[data-search-type="' + Shopify.theme_settings.search_layout + '"]').removeClass('is-opened');
    } else {
      $.fancybox.close($('[data-search-type="' + Shopify.theme_settings.search_layout + '"]'));
    }
  },
  getHeaderHeight: function getHeaderHeight() {
    var headerHeight = $('.header-section').outerHeight() || 0;
    return headerHeight;
  },
  unload: function unload($section) {
    $('.has-overlaid-header').removeClass('has-overlaid-header');
    $('.search-overlay__close, [data-show-search-trigger]').off();
    $('#header').off();
    $('.dropdown-click--true .linklist__list-item').off();
    $('.dropdown-click--false .linklist__list-item').off();
    $('.mobile-menu .linklist__list-item').off();
    this.$menuToggle.off();
    this.disableSticky();
    this.disableOverlayStyle();
  }
};